import { Box, Flex, Skeleton, SkeletonCircle } from '@chakra-ui/react';

const SkeletonRow = ({ cols }: { cols: number }) => (
  <Flex gap="16px" py="8px" borderBottom="1px solid" borderColor="gray.50">
    {Array.from({ length: cols }, (_, i) => (
      <Skeleton key={i} height="10px" flex="1" borderRadius="4px" />
    ))}
  </Flex>
);

const TableSkeletonContent = ({ rows = 5, cols = 4 }) => (
  <Flex flexDir="column" flex="1">
    <Flex
      gap="16px"
      py="10px"
      borderBottom="1px solid"
      borderColor="border-color"
    >
      {Array.from({ length: cols }, (_, i) => (
        <Skeleton key={i} height="10px" flex="1" borderRadius="4px" />
      ))}
    </Flex>
    {Array.from({ length: rows }, (_, i) => (
      <SkeletonRow key={i} cols={cols} />
    ))}
  </Flex>
);

const skeletonMap: Record<string, () => JSX.Element> = {
  card: () => (
    <Flex flexDir="column" justifyContent="space-between" h="100%" p="4px 0">
      <Skeleton height="12px" width="100px" borderRadius="4px" />
      <Flex flexDir="column" gap="8px">
        <Skeleton height="28px" width="70px" borderRadius="6px" />
        <Flex gap="6px" alignItems="center">
          <Skeleton height="10px" width="40px" borderRadius="4px" />
          <Skeleton height="10px" width="90px" borderRadius="4px" />
        </Flex>
      </Flex>
      <Skeleton height="10px" width="60px" borderRadius="4px" />
    </Flex>
  ),

  chart: () => (
    <Flex flexDir="column" h="100%">
      <Skeleton height="12px" width="110px" borderRadius="4px" />
      <Flex
        flex="1"
        alignItems="flex-end"
        gap="10px"
        pt="24px"
        pb="8px"
        px="8px"
      >
        {[35, 55, 45, 70, 40, 60, 30, 50, 65, 38].map((h, i) => (
          <Skeleton
            key={i}
            height={`${h}%`}
            flex="1"
            borderRadius="4px 4px 0 0"
          />
        ))}
      </Flex>
      <Box h="1px" bg="gray.100" mx="8px" />
    </Flex>
  ),

  table: () => (
    <Flex flexDir="column" h="100%">
      <Skeleton height="12px" width="110px" borderRadius="4px" mb="12px" />
      <TableSkeletonContent />
    </Flex>
  ),

  nps_score: () => (
    <Flex flexDir="column" h="100%" alignItems="center" gap="12px">
      <Skeleton
        height="12px"
        width="100px"
        borderRadius="4px"
        alignSelf="flex-start"
      />
      <SkeletonCircle size="120px" mt="4px" />
      <Flex flexDir="column" gap="8px" w="100%">
        {[1, 2, 3].map((i) => (
          <Flex
            key={i}
            justifyContent="space-between"
            py="6px"
            borderBottom="1px solid"
            borderColor="gray.50"
          >
            <Skeleton height="10px" width="80px" borderRadius="4px" />
            <Skeleton height="10px" width="30px" borderRadius="4px" />
          </Flex>
        ))}
      </Flex>
    </Flex>
  ),
};

export const ReportTileSkeleton = ({
  componentType,
}: {
  componentType?: string;
}) => {
  const Skeleton = skeletonMap[componentType] || skeletonMap.chart;
  return <Skeleton />;
};

